export const VIBRATIONAL_ANALYTICS_ACTIONS = {
  GET_PERFORMANCE_DATA: "GET_PERFORMANCE_DATA",
};
